import styled from "styled-components"

import { AlertsSection } from "./AlertsSection"
import { DevicesSection } from "./DevicesSection"
import { OrdersSection } from "./OrdersSection"
import { PerformanceTestsSection } from "./PerformanceTestsSection"
import { SensorsSection } from "./SensorsSection"
import { TotalDataSection } from "./TotalDataSection"
import { TrendsSection } from "./TrendsSection"

const Dashboard = styled.div`
  padding-bottom: 0;

  @media only screen and (max-width: 768px) {
    padding-bottom: 16px;
  }
`

const ContractorDashboard = () => {
  return (
    <Dashboard>
      <TotalDataSection />
      <TrendsSection />
      <DevicesSection />
      <OrdersSection />
      <SensorsSection />
      <AlertsSection />
      <PerformanceTestsSection />
    </Dashboard>
  )
}

export default ContractorDashboard
